module.exports = __webpack_public_path__ + "img/mantis_shrimp.07ca49e1.png";